import { registerScopedBoundary } from "lib/authorization/register-scoped-demand-boundary"

export const ProjectBoundary = registerScopedBoundary("authoring:projectBoundary")
